import React, { useState } from 'react';
import Modal from 'react-modal';
import { StripeEnv } from '../../../util/enums';
import { SnapIcon } from '../../SnapIcon';
import { SnapButton } from '../../SnapButton';

Modal.setAppElement('body');

const computePayoutOptions = (
  stripeEnv: StripeEnv,
): { name: string; label: string }[] => {
  const payoutIntervalOptionsRaise = [
    { name: 'daily', label: 'Daily' },
    { name: 'weekly', label: 'Weekly' },
    { name: 'manual', label: 'At the end of the fundraiser (Default)' },
  ];

  const payoutIntervalOptionsSponsor = [
    { name: 'daily', label: 'Daily' },
    { name: 'weekly', label: 'Weekly' },
    { name: 'monthly', label: 'Monthly' },
  ];
  const mapperObj = {
    RAISE: payoutIntervalOptionsRaise,
    SPONSOR: payoutIntervalOptionsSponsor,
  };
  return mapperObj[stripeEnv] || payoutIntervalOptionsRaise;
};

function ChangePayoutIntervalModal({
  showHeader,
  isOpen,
  stripeEnv,
  toggle,
  onUpdate,
  onCancel,
  defaultInterval,
}: {
  showHeader: boolean;
  isOpen: boolean;
  stripeEnv: StripeEnv;
  defaultInterval?: string;
  toggle: () => void;
  onUpdate: (payoutIntervalSelected: string) => void;
  onCancel: () => void;
}): React.JSX.Element {
  const [payoutInterval, setPayoutInterval] = useState<string | undefined>(
    defaultInterval,
  );
  return (
    <Modal
      // className={`mx-4 mt-16 lg:mx-auto lg:w-[343px] lg:mt-[100px] lg:top-[84px] bg-white rounded-lg`}
      className={`fixed inset-0 flex items-center justify-center`}
      isOpen={isOpen}
      style={{
        content: {
          border: 'none',
          // height: '80vh',
        },
        overlay: {
          zIndex: '99999',
          backgroundColor: 'rgba(0,0,0,0.2)',
        },
      }}
      shouldCloseOnOverlayClick={!showHeader}
    >
      <div className='flex flex-col rounded-lg overflow-auto p-4 bg-white max-w-[343px]'>
        {/** Header */}

        <div
          className={`flex flex-row justify-between p-2 border-b-slate-200 border-b border-solid m-2`}
        >
          <div
            style={{ fontFamily: 'Inter' }}
            className='text-gray-900 text-base not-italic font-bold leading-6'
          >
            Change Payout Intervals
          </div>
          <SnapIcon
            icon={'x-solid'}
            color={'#64748B'}
            onClick={toggle}
            className='cursor-pointer'
          />
        </div>
        {/** Header */}

        {/** Container */}
        <div className='px-4 mb-3 mt-4'>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-lg not-italic font-medium leading-7 text-gray-900'
          >
            Snap! Mobile Payout Intervals
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-base not-italic font-normal leading-6 mt-1'
          >
            Choose how often you would prefer to receive payouts from Snap!
            Mobile.
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='patext-gray-600 text-sm not-italic font-normal leading-5 my-4'
          >
            <span className='text-red-500'>*</span> Indicates a required field.
          </p>
          <p
            style={{ fontFamily: 'Inter' }}
            className='text-gray-900 text-sm not-italic font-medium leading-5 my-4'
          >
            Select Your Payout Intervals <span className='text-red-500'>*</span>
          </p>

          {computePayoutOptions(stripeEnv).map((option, idx) => {
            return (
              <div className='my-4' key={idx}>
                <input
                  type='radio'
                  checked={payoutInterval === option.name}
                  value={option.name}
                  onChange={(e) => setPayoutInterval(e.target.value)}
                />
                <label className='mx-1 text-sm font-medium'>
                  {option.label}
                </label>
              </div>
            );
          })}
        </div>
        {/** Container */}

        {/** Footer */}
        <div className='flex justify-end xs:justify-center md:justify-end border-t-slate-200 border-t border-solid m-1 p-2'>
          <div className='w-full pr-1'>
            <SnapButton
              onClick={onCancel}
              className='mb-2'
              variant='tertiary'
              size='md'
              fullWidth
            >
              Cancel
            </SnapButton>
          </div>
          <div className='w-full pl-1'>
            <SnapButton
              variant='primary'
              size='md'
              fullWidth
              disabled={payoutInterval === undefined}
              onClick={(): void => {
                if (payoutInterval === undefined) {
                  throw new Error('Payout interval not selected');
                }
                onUpdate(payoutInterval);
              }}
            >
              Update
            </SnapButton>
          </div>
        </div>
        {/** Footer */}
      </div>
    </Modal>
  );
}

export default ChangePayoutIntervalModal;
